import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { hideToast } from 'redux/modules/toast/actions';
import styles from 'assets/jss/material-dashboard-pro-react/components/toastStyle';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Close from '@material-ui/icons/Close';
import { Caption, CaptionBold } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

const Toast = () => {
	const toast = useSelector((state: types.redux.rootReducer) => state.toast);
	const dispatch = useDispatch();
	const classes = useStyles();

	const card = classNames({
		[classes.card]: true,
		[classes.cardError]: toast.error,
		[classes.toastActive]: toast.active,
	});

	useEffect(() => {
		if (toast.active) {
			setTimeout(() => dispatch(hideToast()), 5000);
		}
	}, [toast.active, dispatch]);

	return (
		<Card className={card} raised>
			<CardBody className={classes.cardBody}>
				<div className={classes.close} onClick={() => dispatch(hideToast())}>
					<Close />
				</div>
				<div className={classes.actionType}>
					<Caption color="secondary-light" disableMargin>
						{toast.actionType}
					</Caption>
				</div>
				<CaptionBold color="brand" disableMargin>
					{toast.label}
				</CaptionBold>
			</CardBody>
		</Card>
	);
};

export default Toast;
